/**
 * CoLab Map Module
 * Статична карта з тултіпом
 * HTML рендериться на сервері, JS тільки керує інтерактивністю
 */

export const Map = {
    container: null,
    marker: null,
    tooltip: null,
    closeBtn: null,
    isTooltipOpen: false,

    init: function() {
        this.container = document.getElementById('contact-map');

        if (!this.container) {
            console.log('[CoLab.Map] Container not found');
            return;
        }

        this.marker = this.container.querySelector('.map-marker');
        this.tooltip = this.container.querySelector('.map-tooltip');
        this.closeBtn = this.tooltip ? this.tooltip.querySelector('.map-tooltip__close') : null;

        if (!this.marker || !this.tooltip) {
            console.log('[CoLab.Map] Marker or tooltip not found');
            return;
        }

        this.bindEvents();
        console.log('[CoLab.Map] Initialized');
    },

    bindEvents: function() {
        var self = this;

        // Клік на маркер
        this.marker.addEventListener('click', function(e) {
            e.stopPropagation();
            self.toggleTooltip();
        });

        // Keyboard support для маркера
        this.marker.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                self.toggleTooltip();
            }
        });

        // Закриття тултіпа по кнопці
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                self.closeTooltip();
            });
        }

        // Закриття по кліку поза тултіпом
        document.addEventListener('click', function(e) {
            if (self.isTooltipOpen &&
                !self.tooltip.contains(e.target) &&
                !self.marker.contains(e.target)) {
                self.closeTooltip();
            }
        });

        // Закриття по Escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && self.isTooltipOpen) {
                self.closeTooltip();
            }
        });

        // Hover ефект на маркері
        this.marker.addEventListener('mouseenter', function() {
            self.marker.classList.add('is-hovered');
        });

        this.marker.addEventListener('mouseleave', function() {
            self.marker.classList.remove('is-hovered');
        });
    },

    toggleTooltip: function() {
        if (this.isTooltipOpen) {
            this.closeTooltip();
        } else {
            this.openTooltip();
        }
    },

    openTooltip: function() {
        this.tooltip.classList.add('is-open');
        this.marker.classList.add('is-active');
        this.isTooltipOpen = true;

        // Фокус на перший інтерактивний елемент
        var firstFocusable = this.tooltip.querySelector('a, button');
        if (firstFocusable) {
            firstFocusable.focus();
        }
    },

    closeTooltip: function() {
        this.tooltip.classList.remove('is-open');
        this.marker.classList.remove('is-active');
        this.isTooltipOpen = false;

        // Повертаємо фокус на маркер
        this.marker.focus();
    }
};
